import { DateTime, Duration } from 'luxon';
import { JobDetailsService, Location } from 'planning-portal-library/src/lib/core/domain';
export class JobDetails {
    jobId!: string;
    planId!: string;
    jobName!: string;
    jobNumber!: string;
    startAddress!: string;
    endAddress!: string;
    startTerminalName!: string;
    endTerminalName!: string;
    startLatitude!: number;
    startLongitude!: number;
    endLatitude!: number;
    endLongitude!: number;
    distance?: number;
    duration?: Duration;
    durationDisplay?: string;
    distributionLaneId?: string;
    units?: string;
    vehicleType?: string;
    locations!: Location[];
    services!: JobDetailsService[];
    waypoints!: number[][];
    isScheduled?: boolean;
    status?:number;
    startTime!:DateTime;
    endTime!:DateTime; 
    estimatedStartTime!:DateTime;
    estimatedEndTime!:DateTime; 
    jobTemplate!: string;
    jobColor!: string;
    distributionAreaId?: string;
    distributionAreaName?: string;
    startTerminalCity?: string;
    startTerminalPostalCode?: string;
    endTerminalCity?: string;
    endTerminalPostalCode?: string;
}